// Simple in-memory + localStorage token store.
// Used because MSAL's silent token acquisition doesn't work reliably
// in Office Desktop's isolated WebView2 taskpane context.

const TOKEN_KEY = "crm_addin_token";

interface StoredToken {
  accessToken: string;
  username: string;
  expiresAt: number; // ms epoch
}

export function saveToken(accessToken: string, username: string, expiresIn: number) {
  const data: StoredToken = {
    accessToken,
    username,
    expiresAt: Date.now() + expiresIn * 1000 - 60_000, // 1 min early buffer
  };
  localStorage.setItem(TOKEN_KEY, JSON.stringify(data));
}

export function getStoredToken(): string | null {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    if (!raw) return null;
    const data: StoredToken = JSON.parse(raw);
    if (Date.now() > data.expiresAt) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    }
    return data.accessToken;
  } catch {
    return null;
  }
}

export function getStoredUsername(): string | null {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    if (!raw) return null;
    return (JSON.parse(raw) as StoredToken).username;
  } catch {
    return null;
  }
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}
